import { useState } from 'react';

import { TOOL_RENDERERS } from './tool-renderers';

type ToolRendererContext = {
  toolCall: any;
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  onUploadComplete?: (message: { role: string; content: string }) => boolean | void | Promise<boolean | void>;
  uploadAckRetryKey?: string;
};

function usesContextPattern(renderer: (...args: any[]) => unknown): boolean {
  const rendererString = renderer.toString();
  return (
    rendererString.includes('{ toolCall') ||
    rendererString.includes('{toolCall') ||
    rendererString.includes('onUploadComplete')
  );
}

// Wrapper component that always calls useState consistently
function ToolCall({
  toolCall,
  onUploadComplete,
  uploadAckRetryKey,
}: {
  toolCall: any;
  onUploadComplete?: ToolRendererContext['onUploadComplete'];
  uploadAckRetryKey?: string;
}) {
  const [expanded, setExpanded] = useState(false);

  const { toolName, state } = toolCall;
  const tool = TOOL_RENDERERS[toolName] || TOOL_RENDERERS.default;

  if (!tool || !tool[state]) return null;

  const renderer = tool[state];

  if (usesContextPattern(renderer)) {
    return renderer({ toolCall, expanded, setExpanded, onUploadComplete, uploadAckRetryKey });
  }

  // Otherwise, use the old pattern (just pass toolCall directly)
  return renderer(toolCall);
}

export default function ToolCallWrapper({
  toolCall,
  onUploadComplete,
  uploadAckRetryKey,
}: {
  toolCall: any;
  onUploadComplete?: ToolRendererContext['onUploadComplete'];
  uploadAckRetryKey?: string;
}) {
  return <ToolCall toolCall={toolCall} onUploadComplete={onUploadComplete} uploadAckRetryKey={uploadAckRetryKey} />;
}
